import { ImportFormatDataType, ImportFormatItem } from '../../../../../lib/imports/importTypes';
import { InputFormatProvider } from './InputFormatProvider';
import { EntityListProductInputData } from '../entityListTypes';

export class ProductInputFormatProvider extends InputFormatProvider<EntityListProductInputData> {
  getInputFormat(): ImportFormatItem<EntityListProductInputData>[] {
    return [
      {
        id: 'product',
        label: 'Product ID',
        dataType: ImportFormatDataType.STRING,
      },
    ];
  }
}
